import { render, staticRenderFns } from "./Telefonos.vue?vue&type=template&id=b6f74538&scoped=true&"
import script from "./Telefonos.vue?vue&type=script&lang=ts&"
export * from "./Telefonos.vue?vue&type=script&lang=ts&"
import style0 from "./Telefonos.vue?vue&type=style&index=0&id=b6f74538&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f74538",
  null
  
)

export default component.exports